export default {
  URL: process.env.VUE_APP_API_URL,
  ADMIN: process.env.VUE_APP_ADMIN_URL,
};

const normalizeCountryCode = (value) => String(value || "").trim().toUpperCase();

const parseCountryListEnv = (value) => {
  const normalizedValue = String(value || "").trim();

  if (!normalizedValue || normalizedValue.toLowerCase() === "false") {
    return [];
  }

  if (normalizedValue.toLowerCase() === "true") {
    return ["*"];
  }

  return normalizedValue
    .split(",")
    .map((countryCode) => normalizeCountryCode(countryCode))
    .filter(Boolean);
};

const newDashboardCountries = parseCountryListEnv(
  process.env.VUE_APP_NEW_DASHBOARD
);

const includesCountry = (countryList, countryCode) =>
  countryList.includes("*") || countryList.includes(countryCode);

const usesNewDashboard = (countryCode) => {
  const normalizedCountryCode = normalizeCountryCode(countryCode);

  if (!normalizedCountryCode) {
    return false;
  }

  return includesCountry(newDashboardCountries, normalizedCountryCode);
};

export const DASHBOARD_SETTINGS = {
  NEW_DASHBOARD_COUNTRIES: newDashboardCountries,
  usesOldDashboard(countryCode) {
    return !usesNewDashboard(countryCode);
  },
  usesNewKpiDashboard(countryCode) {
    return usesNewDashboard(countryCode);
  },
};

export const TENANCY_SETTINGS = {
  TENANCY: process.env.VUE_APP_TENANCY === "true",
  TENANCY_COUNTRY: process.env.VUE_APP_TENANCY_COUNTRY,
  TENANCY_LOCAL: process.env.VUE_APP_TENANCY_LOCAL === "true",
};

export const ONBOARDING_SETTINGS = {
  USE_MARKETING_CONSENTS_ONBOARDING: process.env.VUE_APP_USE_MARKETING_CONSENTS_ONBOARDING === "true",
};

const PORTAL_HOME_TENANT_CODES = new Set(["PL", "CZ", "HU", "SK"]);

export const PORTAL_HOME_SETTINGS = {
  isEnabled() {
    return process.env.VUE_APP_PORTAL_HOME === "true";
  },
  isTenantEligible(tenantCountryCode) {
    const c = String(tenantCountryCode || "").trim().toUpperCase();
    return PORTAL_HOME_TENANT_CODES.has(c);
  },
};

export const ONLINE_TRAINING_TYPES = {
  GENERAL: "general",
  PRODUCT: "product",
};
